import api from "../../index.js";
import { qs } from "../../../utils/utils.js";

export const GetCommissionApi = (params) => api.get(`ibusermaster/myearning-ibcommissionreports?${qs(params)}`);
export const GetCommissionAssignTreeApi = (userId, params) => api.get(`ibusermaster/ib-commission-assign-tree/${userId}?${qs(params)}`);
export const GetCommissionlotApi = (params) => api.get(`ibusermaster/get-total-commission-lots?${qs(params)}`);